import gql from "graphql-tag";

export const PhotoFragment = gql`
  fragment Photo on PhotoObjectType {
    id
    main
    storageUrl
  }
`;
